import { render, staticRenderFns } from "./topicProceeDetail.vue?vue&type=template&id=0e94a616&scoped=true"
import script from "./topicProceeDetail.vue?vue&type=script&lang=js"
export * from "./topicProceeDetail.vue?vue&type=script&lang=js"
import style0 from "./topicProceeDetail.vue?vue&type=style&index=0&id=0e94a616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e94a616",
  null
  
)

export default component.exports